import { lazy, Suspense } from "react";

const OrdersCalendar = lazy(() => import("../screens/Ordering/OrdersCalendar"));

const OrderingRoutes = {
  path: "ordering",
  children: [
    {
      path: "orderscalendar",
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <OrdersCalendar />
        </Suspense>
      ),
    },
  ],
};

export default OrderingRoutes;
